module.exports = __webpack_public_path__ + "img/collection-engagementRingsLabGrownDiamonds.4d9d7bd.webp";